import $ from 'jquery';

/**
 * Cookie functions
 */

function setCookie(cname, cvalue, exdays) {
    const d = new Date();
    d.setTime(d.getTime() + (exdays*24*60*60*1000));
    let expires = 'expires='+ d.toUTCString();
    document.cookie = cname + '=' + cvalue + ';' + expires + ';path=/';
}

function getCookie(cname) {
    let name = cname + "=";
    let decodedCookie = decodeURIComponent(document.cookie);
    let ca = decodedCookie.split(';');
    for(let i = 0; i <ca.length; i++) {
        let c = ca[i];
        while (c.charAt(0) == ' ') {
            c = c.substring(1);
        }
        if (c.indexOf(name) == 0) {
            return c.substring(name.length, c.length);
        }
    }
    return '';
}

/**
 * Check if element is in viewport
 */

function isElementInViewport(el) {
    let rect = el.getBoundingClientRect();
    return (
        rect.top >= 0 &&
        rect.left >= 0 &&
        rect.bottom <=
        (window.innerHeight || document.documentElement.clientHeight) &&
        rect.right <= (window.innerWidth || document.documentElement.clientWidth)
    );
}

/**
 * Wait for variable to be set
 */
function waitFor(variable, callback) {
    var interval = setInterval(function() {
        if (window[variable]) {
            clearInterval(interval);
            callback();
        }
    }, 200);
}

/**
 * Mobile navigation toggle
 */

const toggleMenu = (event) => {
    event.preventDefault();
    $('.js-menu-toggle, .nav--header').toggleClass('open');
    $('.header').toggleClass('menu-open');
};

$('.js-menu-toggle').on('click', toggleMenu);

/**
 * Intro video
 */

const returnUser = getCookie('return_user');
const introVideo = document.getElementById('intro-video');

if (introVideo) {
    if (returnUser !== 'true') {
        window.addEventListener('load', function(event) {
            setTimeout(function() {
                $('html').addClass('return-user');
                setCookie('return_user', true, 1825);
            }, 3000);
        });
    }
}

/**
 * YouTube videos
 */

let tag = document.createElement('script');
    tag.src = 'https://www.youtube.com/iframe_api';
    
let firstScriptTag = document.getElementsByTagName('script')[0];
    firstScriptTag.parentNode.insertBefore(tag, firstScriptTag);

const youtubeVideos = document.querySelectorAll('.youtube-player');

youtubeVideos.forEach(function(video, i) {
    let player,
        playerID = video.id,
        videoID = video.dataset.id;

    window.onYouTubeIframeAPIReady = function() {
        console.log = 'READY';
        player = new YT.Player(playerID, {
            height: '390',
            width: '640',
            videoId: videoID,
            playerVars: {
                'playsinline': 1,
                rel: 0,
                modestbranding: 1,
                origin: location.href,
                widget_referrer : location.href
            },
            events: {
                'onReady': onPlayerReady,
                'onStateChange': onPlayerStateChange
            }
        });
    }

    function onPlayerReady(event) {
        //event.target.playVideo();
    }

    let done = false;
    function onPlayerStateChange(event) {
        if (event.data == YT.PlayerState.PLAYING && !done) {
            setTimeout(stopVideo, 6000);
            done = true;
        }
    }

    function stopVideo() {
        player.stopVideo();
    }
});

/**
 * Fixed header
 */

$(document).ready(function() {
    let scroll = $(window).scrollTop();

    if (scroll > 0) {
        $('header').addClass('scrolled');
    } else {
        $('header').removeClass('scrolled');
    }
});

$(window).scroll(function() {    
    scroll = $(window).scrollTop();

    if (scroll > 0) {
        $('header').addClass('scrolled');
    } else {
        $('header').removeClass('scrolled');
    }
});

/**
 * Accordions
 */

$('.accordion__item-title button').click(function(e) {
    e.preventDefault();
    const $selectedAccordion = $(this).closest('.accordion__item');
    $selectedAccordion.toggleClass('open');
    $('.accordion__item-content', $selectedAccordion).slideToggle( 'fast', function() {
        // Animation complete.
    });
});

/**
 * Sliders
 */

let getNextSibling = function (elem, selector) {
    var sibling = elem.nextElementSibling;
    if (!selector) return sibling;
    while (sibling) {
        if (sibling.matches(selector)) return sibling;
        sibling = sibling.nextElementSibling
    }
};

let currImg = 0,
    delay = 1500,
    sliderTimeout = null;

function showNextImg(images) {
    for (var i = 0; i < images.length; i++) {
        images[i].style.opacity = 0;
    }

    images[currImg].style.opacity = 1;

    currImg = (currImg != images.length - 1) ? currImg + 1 : 0;
    sliderTimeout = setTimeout(function() {
        showNextImg(images);
    }, delay)
}

document.querySelectorAll('.egonaut-slider__images').forEach(function(slider) {
    slider.addEventListener('mouseenter', function() {
        console.log(slider.parentNode);
        showNextImg(slider.parentNode.querySelectorAll('.attachment-large'));
    })
    slider.addEventListener('mouseout', function() {
        clearTimeout(sliderTimeout);
    })
});

/**
 * Roadmap
 */
$(function () {

    let timeline = $('.timeline');

    if (timeline.length) {

        $(window).on('scroll', function () {
            timelineScroll();
        });

        $(window).on('resize', function () {
            timelineResize();
        });

        let timelineLine = $('.timeline__line'),
            timelineLineProgress = $('.timeline__line-progress'),
            timelinePoint = $('.timeline__card-point'),
            timelineItem = $('.timeline__item'),
            windowOuterHeight = $(window).outerHeight(),
            windowHeight = $(window).height(),
            f = -1,
            i,
            a,
            n,
            posY,
            timelineFlag = false;

        function timelineScroll() {
            posY = $(window).scrollTop();

            timelineUpdateFrame();
        }

        function timelineResize() {
            posY = $(window).scrollTop();
            windowHeight = $(window).height();

            timelineUpdateFrame();
        }

        function timelineUpdate() {
            timelineFlag = false;

            timelineLine.css({
                top: 50,
                bottom: timeline.offset().top + timeline.outerHeight() - timelineItem.last().find(timelinePoint).offset().top
            });

            f !== posY && (f = posY, windowHeight, timelineProgress());
        }

        function timelineProgress() {
            var agTop = timelineItem.last().find(timelinePoint).offset().top;

            i = agTop + posY - $(window).scrollTop();
            a = timelineLineProgress.offset().top + posY - $(window).scrollTop();
            n = posY - a + windowOuterHeight / 2;
            i <= posY + windowOuterHeight / 2 && (n = i - a);
            timelineLineProgress.css({height: n + "px"});

            timelineItem.each(function () {
            var agTop = $(this).find(timelinePoint).offset().top;

            (agTop + posY - $(window).scrollTop()) < posY + .7 * windowOuterHeight ? $(this).addClass('timeline__item-active') : $(this).removeClass('timeline__item-active');
            })
        }

        function timelineUpdateFrame() {
            timelineFlag || requestAnimationFrame(timelineUpdate);
            timelineFlag = true;
        }

    }

});

/**
 * Opensea API
 */
$(function () {

    const ownedEgonautsCont = $('#owned-egonauts');

    if (ownedEgonautsCont.length) {
        waitFor('userWallet', function() {
            const formData = new FormData();
            formData.append('wallet_address', userWallet);
            formData.append('contract_slug', 'egonauts');
            formData.append('action', 'get_assets');

            $.ajax({
                type: 'POST',
                url: ajax_object.ajaxurl,
                data: formData,
                processData: false,
                contentType: false,
                dataType: 'json',
                success: function(data, textStatus, jqXHR) {
                    let ownedEgonauts = data.nfts;

                    if (ownedEgonauts.length) {
                        $.each(ownedEgonauts, function(i, egonaut) {
                            const id = egonaut.identifier;
                            const name = egonaut.name;
                            const imageUrl = egonaut.image_url;
                            $('.row', ownedEgonautsCont).append(`
                                <div class="owned-egonaut col col--xs-12 col--md-5 col--lg-4">
                                    <div class="egonat-series__info gold-border">
                                        <div class="egonaut-series__thumbnail">
                                            <img src="${imageUrl}" />
                                        </div>
                                    </div>
                                    <span>${name}</span>
                                </div>
                            `);
                        });
                    } else {
                        $('.row', ownedEgonautsCont).append('<h3>No Egonauts found</h3>');
                    }
                },
                error: function (request, status, error) {
                    console.log(error);
                }
            });
        });
    }
});